var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title bg-gray-200"},[_c('div',{staticClass:"container mx-auto py-6 text-2xl font-semibold text-push-orange"},[_c('h1',{staticClass:"ml-6 lg:ml-auto"},[_vm._v(_vm._s(_vm.$attrs.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }